import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Person Off Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-person-off-outline',
    templateUrl: './icon-person-off-outline.component.html',
    styleUrls: ['./icon-person-off-outline.component.scss'],
    standalone: false
})
export class IconPersonOffOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
